//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class PersonGroupService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[PersonGroup.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/person-group/detail', {'params':params});
	};

	//GeneratorFlag:[PersonGroup.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/person-group/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}